// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"530":"page","820":"serviceList","945":"dashboard"}[chunkId] || chunkId) + "." + {"91":"aaf28a70","530":"399e42cd","820":"450d2af9","945":"17de8742"}[chunkId] + ".css";
};